import React from 'react';
import { APP_CONTAINER_ROUTES } from '@/navigators/routes';
import { AppContainerStackParams } from '@/navigators/types';
import { createStyles } from '@/contexts/theme-context';
import { OriginalInboundContent } from '@/contexts/original-inbound-content';
import { OriginalInboundSkeleton } from './original-inbound-skeleton';
import { PageContainer } from '@/components/page-container';
import { Platform } from 'react-native';
import { StackScreenProps } from '@react-navigation/stack';
import { useOriginalInboundMetadataQuery } from '@/hooks/use-original-inbound-metadata-query';
import { WEB_MARGIN_TOP } from './utils';

type Props = StackScreenProps<
  AppContainerStackParams,
  APP_CONTAINER_ROUTES.OriginalInbound
>;

export const OriginalInboundDetailScreen: React.FC<Props> = ({ route }) => {
  const { filterBySubmittedOrderUUID, orderMetadata } = route.params;
  const [styles, theme] = useStyles();

  const { data, loading } = useOriginalInboundMetadataQuery({
    filterBySubmittedOrderUUID,
    orderMetadata,
  });

  const webPaddingStyle = Platform.OS === 'web' ? styles.pageHeaderWeb : null;

  return (
    <PageContainer
      animateNavigationHeader
      containerStyle={styles.background}
      navigationHeaderProps={{
        containerStyle: styles.background,
        contentContainerStyle: webPaddingStyle,
        showBackButton: true,
        showShadow: false,
      }}
      showNavigationHeader
      statusBarColor={theme.sk.color.bg.secondary.default}
    >
      {() => (
        <>
          {loading ? (
            <OriginalInboundSkeleton />
          ) : (
            <OriginalInboundContent isSummaryView orderMetadata={data} />
          )}
        </>
      )}
    </PageContainer>
  );
};

const useStyles = createStyles((theme) => ({
  background: {
    backgroundColor: theme.sk.color.bg.secondary.default,
  },
  pageHeaderWeb: {
    paddingTop: WEB_MARGIN_TOP,
  },
}));
